import React from 'react';

export default function Times() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5697 12.0002L23.6488 3.92119C24.1161 3.45394 24.1161 2.69569 23.6488 2.22769L21.7715 0.350438C21.3043 -0.116812 20.546 -0.116812 20.078 0.350438L11.9996 8.43019L3.9205 0.351188C3.45324 -0.116062 2.69498 -0.116062 2.22697 0.351188L0.350443 2.22769C-0.116814 2.69494 -0.116814 3.45319 0.350443 3.92119L8.42957 12.0002L0.350443 20.0792C-0.116814 20.5464 -0.116814 21.3047 0.350443 21.7727L2.22772 23.6499C2.69498 24.1172 3.45324 24.1172 3.92125 23.6499L11.9996 15.5702L20.0788 23.6492C20.546 24.1164 21.3043 24.1164 21.7723 23.6492L23.6496 21.7719C24.1168 21.3047 24.1168 20.5464 23.6496 20.0784L15.5697 12.0002Z" />
    </svg>
  );
}
